import type { ReactElement, JSXElementConstructor } from 'react'
import React from 'react'
import { useCheckAuth } from '@/hooks'
import withCheckAuthorization from '../withCheckAuthorization'
import { Menu } from 'antd'

interface Iprop {
  authCode?: string
  noAuth?: React.ReactNode
  children: ReactElement<any, string | JSXElementConstructor<any>>
}
const AuthComponent = (props: Iprop) => {
  const { authCode, noAuth, children } = props
  const { checkAuth } = useCheckAuth()
  const hasAuth = checkAuth(authCode)
  return <>{hasAuth ? children : noAuth || ''}</>
}

export const AuthMenuItem = withCheckAuthorization(Menu.Item)

export default AuthComponent
